import { useGetNetSuiteExchangeRates } from 'shared/data/webApp/v1';

export const useExchangeRates = (
    companyId?: string,
    forDate?: string | null,
    baseCurrencyInternalId?: string | null,
    isDisabled = false
) => {
    return useGetNetSuiteExchangeRates(
        { query: { companyId, forDate, baseCurrencyInternalId } },
        { enabled: Boolean(forDate) && !isDisabled }
    );
};
